<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Definir Hierarquia - Lider / Liderados
      </p>
    </div>
    <section class="text-weight-bold font text-brand-5">Usuario</section>
    <div class="row">
      <div class="col-md-2 q-ml-sm q-mt-md">
        <q-input
          ref="inputRef"
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          label="Nome"
          dense
          :disable="true"
          outlined
          v-model="dados.nome"
        />
      </div>
      <div class="col-md-2 q-ml-sm q-mt-md">
        <q-input
          ref="inputRef3"
          label="Email"
          dense
          :disable="true"
          outlined
          :rules="[(val) => !!val || 'Campo Obrigatório']"
          v-model="dados.email"
        />
      </div>
      <div class="col-md-2 q-ml-sm q-mt-md">
        <q-input
          ref="inputRef2"
          label="Matricula, Sap, RE, ID ou outro identificado único"
          dense
          :disable="true"
          outlined
          :rules="[(val) => val != '' || 'Campo Obrigatório']"
          v-model="dados.id"
        />
      </div>
    </div>
    <div v-if="leader" class="col-md-2 q-ml-sm q-mt-sm">
      <span
        ><span class="text-weight-bold">Lider: </span> {{ leader.name }} -
        {{ leader.email }} - SAP: {{ leader.sap }}</span
      >
    </div>
    <div class="row">
      <div class="col-md-2 q-ml-sm q-mt-md">
        <q-btn
          color="primary"
          class="q-ml-sm"
          label="DEFINIR / ALTERAR LIDER"
          @click="lider = true"
        />
      </div>
      <div class="col-md-2 q-mt-md">
        <q-btn
          color="secondary"
          class="q-ml-sm"
          label="REMOVER LIDER"
          @click="desvincularLider"
        />
      </div>
    </div>

    <table-libera-prazo v-if="lider" @usuario="getLider" />
    <table-liderados :liderados="user" @atualizarDados="getData" />
    <div class="row">
      <div class="col-md-2 q-mt-md">
        <q-btn
          color="positive"
          class="q-ml-sm"
          label="INCLUIR NOVOS LIDERADOS"
          @click="prazo = true"
        />
      </div>
    </div>
    <table-libera-prazo v-if="prazo" @usuario="getUsuario" />
  </q-page>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useQuasar } from "quasar";
import TableLiderados from "../components/TableLiderados.vue";
import TableLiberaPrazo from "../components/TableLiberaPrazo.vue";
export default {
  components: { TableLiderados, TableLiberaPrazo },
  setup() {
    const route = useRoute();
    const store = useStore();
    const id = route.params.id;
    const quasar = useQuasar();
    const user = ref("");
    const prazo = ref(false);
    const lider = ref(false);
    const dados = ref({
      nome: "",
      id: "",
      email: "",
    });
    const leader = ref("");
    const getData = async () => {
      try {
        let response = await store.dispatch("user/getUserEspecifico", {
          id: id,
        });

        user.value = response.data.model;

        dados.value.nome = response.data.model.name;
        dados.value.id = response.data.model.sap;
        dados.value.email = response.data.model.email;
        leader.value = response.data.model.leader;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getData);

    const getUsuario = async (usuario) => {
      try {
        await store.dispatch("user/setLiderado", {
          liderado: usuario,
          id: user.value.id,
        });
        quasar.notify({
          message: "Liderado adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getData();
      } catch (error) {
        quasar.notify({
          message: "Erro a o adicionar liderado",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getLider = async (usuario) => {
      try {
        await store.dispatch("user/setLider", {
          lider: usuario,
          id: user.value.id,
        });
        quasar.notify({
          message: "Lider adicionado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getData();
      } catch (error) {
        quasar.notify({
          message: "Erro a o adicionar lider",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desvincularLider = async () => {
      try {
        await store.dispatch("user/desvincularLider", {
          id: user.value.id,
        });
        getData();
        quasar.notify({
          message: "Lider removido com sucesso",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o remover lider",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    return {
      dados,
      getData,
      user,
      prazo,
      getUsuario,
      desvincularLider,
      lider,
      getLider,
      leader,
    };
  },
};
</script>

<style scoped>
.font {
  font-size: 20px;
}
</style>
